import { render, staticRenderFns } from "./Lawyer.vue?vue&type=template&id=7cb345cf&scoped=true&"
import script from "./Lawyer.vue?vue&type=script&lang=js&"
export * from "./Lawyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb345cf",
  null
  
)

export default component.exports